import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class CanActivateViaOAuthGuard implements CanActivate {

  constructor(public router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem("token") === null) {
      
     // localStorage.setItem("should_load_captcha", "true");
      this.router.navigate(['/login'], { queryParams: { nav: state.url } });
      return false;
    }

    let tokenObj: any = JSON.parse(localStorage.getItem("token"));
    let now = new Date(new Date().getTime());
    let expiredDate = new Date(tokenObj.expires);

    if (!expiredDate) {
      this.router.navigate(['/login'], { queryParams: { nav: state.url } });
      return false;
    }

    if (expiredDate < now) {
      this.router.navigate(['/login'], { queryParams: { nav: state.url } });
      return false;
    }

    return (tokenObj.token === null) ? false : true;
  }
}